import NotFoundComp from "../../components/pages/not-found";
function NotFound() {
  return <NotFoundComp />;
}
export default NotFound;
